import { useEffect, useState } from "react";
import ClassHomeDemo2 from "../CommanComponents/ClassHomeDemo2";
import ClassHomeDemo3 from "../CommanComponents/ClassHomeDemo3";
import ClassHomeDemo4 from "../CommanComponents/ClassHomeDemo4";
import TeacherPage from "../teacher/TeacherPage";
import Navbar from "../CommanComponents/Navbar";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { scoreArray } from "../redux/slice/ScoreSlice";
import { contentArray } from "../redux/slice/ContentArraySlice";
import DemoPage from "../CommanComponents/DemoPage";
import api from "../utils/api";

function Home() {
  const [activeCategory, setActiveCategory] = useState(null);
  const [userName, setUserName] = useState("Öğrenci");
  const [yourClassroom, setYourClassroom] = useState(true);
  const [packageControl, setpackageControl] = useState();
  //teacher component ayarlanması
  const count = useSelector((state) => state.activeComponent.value);
  const dispatch = useDispatch();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("postUser"));
    if (!user) return;
    setUserName(user.username);
    setpackageControl(user.purchasedPackages);
    // 1. Aşama: Rol Kontrolü
    if (user.role === "teacher") {
      setActiveCategory(4);
    }
    // 2. Aşama: Öğrenci ve Paket Kontrolü
    else if (user.purchasedPackages.length > 0) {
      // console.log(user.purchasedPackages, "paket mevcut");
      user.purchasedPackages.forEach((item) => {
        // Paket ID'sine göre kategori belirleme
        switch (item.packageId) {
          case "Class 2":
            if (count === 0) {
              setActiveCategory(1);
            } else {
              setActiveCategory(count);
            }
            break;
          case "Class 3":
            if (count === 0) {
              setActiveCategory(2);
            } else {
              setActiveCategory(count);
            }

            break;
          case "Class 4":
            if (count === 0) {
              setActiveCategory(3);
            } else {
              setActiveCategory(count);
            }

            break;
          default:
            // Tanımlı olmayan bir paket gelirse yapılacak işlem (opsiyonel)
            break;
        }
      });
    }
    // 3. Aşama: Paket Yoksa
    else {
      setActiveCategory(0);
    }
  }, []);

  useEffect(() => {
    const fetchUserAndScore = async () => {
      const user = JSON.parse(localStorage.getItem("postUser"));
      if (user) {
        const scoreInfo = await getScore(user._id);

        if (scoreInfo) {
          dispatch(scoreArray(scoreInfo));
          const contentArrays = scoreInfo.contentArray || [];
          dispatch(contentArray(contentArrays));
        }
      }
    };
    fetchUserAndScore();
  }, []);

  const getScore = async () => {
    try {
      const res = await api.get("getUserByScore");
      return res.data;
    } catch (error) {
      console.error("Error get score:", error);
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col w-full
       justify-center items-center gap-4 "
      style={{
        fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
      }}
    >
      <div className="w-full rounded-2xl ">
        <Navbar
          setActiveCategory={setActiveCategory}
          activeCategory={activeCategory}
        />
      </div>

      {yourClassroom ? (
        <div className="w-full">
          {/* Learning categories with icons */}
          {activeCategory === 0 && <DemoPage />}
          {activeCategory === 1 && <ClassHomeDemo2 />}
          {activeCategory === 2 && <ClassHomeDemo3 />}
          {activeCategory === 3 && <ClassHomeDemo4 />}
          {activeCategory === 4 && <TeacherPage />}
        </div>
      ) : (
        <div>
          <h2 className="text-2xl font-bold">Welcome to Your Classroom</h2>
          <p className="mt-4">
            Here you can find all your classes and resources.
          </p>
        </div>
      )}
    </div>
  );
}

export default Home;
